module.exports = __webpack_public_path__ + "dc0f49055db622ab4fc476e7b2fadc2a.png";